import About from "./AboutUs";
import Services from "./Services";
import WhyChooseUs from "./WhyChooseUs";
import ServiceAreas from "./ServiceAreas";
import Reviews from "./Reviews";
import FAQs from "./FAQs";
import CTASection from "../../../reusableUi/CTA";
import Process from "../../../reusableUi/Process";

export default function Main() {
  return (
    <main className="space-y-25">
      <Services />
      <WhyChooseUs />
      <Reviews />
      <Process />
      <ServiceAreas />
      <FAQs />
      <CTASection />
      <About />
    </main>
  );
}
